import {
  DetailedMetricTableResponse,
  OutcomeAnalysisRequest,
  PostOutcomeTrackerBenefitTakeupResponse,
} from '../../api-models/types.gen';
import { OutcomeDetailedMetricsTab } from '../../types/table.type';
import adaptTable from './outcomeTrackerAdaptTable';
import { HTTPMethod } from '../../types/enums';
import { AdapterInterface } from '../../types/global';

import BaseAdapter from './baseAdapter';
import outcomeTrackerAdaptRequest, { OutcomeTrackerAdaptRequestProps } from './outcomeTrackerAdaptRequest';

export default class PostOutcomeTrackerBenefitTakeup extends BaseAdapter<DetailedMetricTableResponse[]> implements AdapterInterface {
  rawResponse: PostOutcomeTrackerBenefitTakeupResponse;

  modifiedRequest: OutcomeAnalysisRequest;

  async adaptResponse(request: OutcomeTrackerAdaptRequestProps, signal?: AbortSignal): Promise<OutcomeDetailedMetricsTab[]> {
    const formattedRequest = this.adaptRequest(request);
    await this.fetchApiResponse('/api/outcome-tracker/benefit-takeup', HTTPMethod.Post, formattedRequest, signal);
    return this.rawResponse.map(adaptTable);
  }

  adaptRequest(request: OutcomeTrackerAdaptRequestProps): OutcomeAnalysisRequest {
    this.modifiedRequest = outcomeTrackerAdaptRequest(request);
    return this.modifiedRequest;
  }
}
